import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const defaultGetToken = async () => null;
const AuthTokenContext = createContext(defaultGetToken);
export function AuthTokenProvider({ children, getToken, }) {
    return (_jsx(AuthTokenContext.Provider, { value: getToken ?? defaultGetToken, children: children }));
}
export function useAuthToken() {
    return useContext(AuthTokenContext);
}
